import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import { qk } from '../keys';
import type { Paginated, QuoteRecord, QuoteRequest, QuoteResult, QuoteSendInput } from '../types';

/**
 * Изчислението е POST, защото носи цяло направление, но НЕ променя нищо —
 * затова резултатът се държи в кеша на мутацията и екранът не мига.
 */
export function useCalculateQuote() {
  return useMutation({
    mutationFn: (input: QuoteRequest) => api.post<QuoteResult>('/quotes/calculate', input),
  });
}

export function useSendQuote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: QuoteSendInput) => api.post<QuoteRecord>('/quotes', input),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: qk.quotes.all }),
  });
}

export function useQuotes() {
  return useQuery({
    queryKey: qk.quotes.list(),
    queryFn: () => api.get<Paginated<QuoteRecord>>('/quotes', { perPage: 50 }),
    staleTime: 60_000,
  });
}
